export default __webpack_public_path__ + "static/Varias01-1a6489b93b9dd34bd2d438646a8a2d80.svg";